import React, { useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight, FileText, FileEdit, Printer, Smartphone, ArrowRight } from 'lucide-react';
const items = [{
  num: '01',
  emoji: '📖',
  pages: '+200 pagine',
  title: 'I 6 Volumi del Metodo',
  desc: 'Guida completa con spiegazioni, disegni tecnici e progressioni graduali.',
  format: 'PDF + Word'
}, {
  num: '02',
  emoji: '📋',
  pages: '40+ pagine',
  title: 'Registro di Valutazione Posturale',
  desc: 'Griglie di osservazione e schede di salute pronte da consegnare alle tue allieve.',
  format: 'PDF + Word'
}, {
  num: '03',
  emoji: '💪',
  pages: '80+ pagine',
  title: 'Manuale Reformer Esplosivo',
  desc: 'Sequenze dinamiche che integrano forza, controllo e respirazione.',
  format: 'PDF + Word'
}, {
  num: '04',
  emoji: '🗂️',
  pages: '30+ pagine',
  title: 'Il Raccoglitore (Schede Rapide)',
  desc: 'Mappe visive da tenere accanto al Reformer come guida di consultazione rapida.',
  format: 'PDF + Word'
}];
const formatChips = [{
  icon: FileText,
  label: 'PDF alta qualità'
}, {
  icon: FileEdit,
  label: 'Word editabile'
}, {
  icon: Printer,
  label: 'Stampabile in A4'
}, {
  icon: Smartphone,
  label: 'Tablet & mobile'
}];
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/6REUG82Zv8s2oAoYWQWa4q/Captura_de_pantalla_2026-04-21_a_la(s)_9.50.39_p._m..png',
  alt: 'Lezioni di Colonna Vertebrale 360° e Sfida di Equilibrio'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/83UXugSTaYPb5nBZnSm7YX/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.00_p._m..png',
  alt: 'Blocco 2 — Mat con Palla di Pilates'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qbZQXApTLqzh6dtjnVuKio/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.30_p._m..png',
  alt: 'Protocollo 6 — Ipercifosi Dorsale'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gY8KnQV3RHYxmS85GJQoiS/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.51_p._m..png',
  alt: 'Riepilogo Lezioni per Trimestre'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v6kjBisUPgP1AWRBhtDGNn/Captura_de_pantalla_2026-04-21_a_la(s)_9.52.18_p._m..png',
  alt: 'Mat Express 30 Online — Lezione Virtuale'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t6qsPcqgp3RASMAVk9fU3g/Captura_de_pantalla_2026-04-21_a_la(s)_9.53.35_p._m..png',
  alt: 'Foglio Maestro delle Tariffe — Tabella Prezzi'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const center = container.scrollLeft + container.clientWidth / 2;
    let minDistance = Infinity;
    let active = 0;
    Array.from(container.children).forEach((child, index) => {
      const childCenter = (child as HTMLElement).offsetLeft + (child as HTMLElement).clientWidth / 2;
      const distance = Math.abs(center - childCenter);
      if (distance < minDistance) {
        minDistance = distance;
        active = index;
      }
    });
    setActiveIndex(active);
  };
  const scrollToIndex = (index: number) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const child = container.children[index] as HTMLElement;
    if (!child) return;
    const scrollLeft = child.offsetLeft - container.clientWidth / 2 + child.clientWidth / 2;
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  const scrollPrev = () => {
    if (activeIndex > 0) scrollToIndex(activeIndex - 1);
  };
  const scrollNext = () => {
    if (activeIndex < carouselImages.length - 1) scrollToIndex(activeIndex + 1);
  };
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-55">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-56"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-57">
        <div className="text-center mb-10 sm:mb-12" data-id="element-58">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-59">
            📦 Accesso immediato
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-60">
            Questo ricevi nella tua email{' '}
            <span className="text-primary" data-id="element-61">oggi stesso</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-62">
            <span className="text-text-main font-bold" data-id="element-63">
              +350 pagine di materiale professionale
            </span>{' '}
            scaricabili all'istante, senza aspettare spedizioni.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mt-6" data-id="element-64">
            {formatChips.map((c, i) => {
            const Icon = c.icon;
            return <span key={i} className="inline-flex items-center gap-1.5 bg-bg-alt border border-border-light text-text-main text-[11px] sm:text-xs font-bold px-2.5 py-1.5 rounded-full" data-id="element-65">
                  <Icon className="w-3.5 h-3.5 text-cta-green" data-id="element-66" />
                  {c.label}
                </span>;
          })}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6" data-id="element-67">
          {items.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 hover:border-primary/40 hover:shadow-[0_18px_40px_-15px_rgba(139,111,191,0.3)] transition-all duration-300 shadow-[0_4px_18px_-10px_rgba(90,70,120,0.12)]" data-id="element-68">
              <div className="bg-gradient-to-r from-primary via-primary to-pink-400 h-1 w-full" data-id="element-69" />

              <div className="flex-1 flex flex-col p-6 sm:p-7 relative" data-id="element-70">
                <span className="absolute top-5 right-5 text-primary/30 font-black text-3xl sm:text-4xl leading-none select-none" data-id="element-71">
                  {item.num}
                </span>

                <span className="text-4xl sm:text-5xl mb-3 block relative z-10" data-id="element-72">
                  {item.emoji}
                </span>

                <div className="flex flex-wrap items-center gap-1.5 mb-3" data-id="element-73">
                  <span className="inline-block text-primary font-black text-[11px] sm:text-xs bg-primary/10 px-2.5 py-1 rounded-full border border-primary/20 uppercase tracking-wider" data-id="element-74">
                    {item.pages}
                  </span>
                  <span className="inline-block text-cta-green font-bold text-[11px] sm:text-xs bg-cta-green/10 px-2.5 py-1 rounded-full border border-cta-green/20" data-id="element-75">
                    {item.format}
                  </span>
                </div>

                <h3 className="text-lg sm:text-xl font-black text-text-main leading-snug mb-2" data-id="element-76">
                  {item.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-77">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 sm:mt-20 relative" data-id="element-78">
          <div className="text-center mb-8 sm:mb-10" data-id="element-79">
            <p className="inline-block bg-cta-green/10 text-cta-green font-bold uppercase tracking-wider text-[10px] sm:text-xs px-3 py-1 rounded-full border border-cta-green/20 mb-3" data-id="element-80">
              📸 Immagini reali del materiale — senza simulazioni
            </p>
            <h3 className="text-2xl sm:text-3xl font-black text-text-main" data-id="element-81">
              Guarda il materiale dall'interno
            </h3>
            <p className="text-text-sec text-sm mt-3 sm:hidden inline-flex items-center justify-center gap-1.5" data-id="element-82">
              <ChevronLeft className="w-4 h-4 animate-pulse" data-id="element-83" />
              Scorri per vedere di più
              <ChevronRight className="w-4 h-4 animate-pulse" data-id="element-84" />
            </p>
          </div>

          <div className="relative group max-w-[100vw] -mx-4 sm:mx-0" data-id="element-85">
            <button onClick={scrollPrev} className={`hidden sm:flex absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-bg-alt hover:bg-white border border-border-light p-3 rounded-full text-text-main transition-all shadow-[0_8px_20px_-6px_rgba(90,70,120,0.25)] ${activeIndex === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Precedente" data-id="element-86">
              <ChevronLeft className="w-5 h-5" data-id="element-87" />
            </button>
            <button onClick={scrollNext} className={`hidden sm:flex absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-bg-alt hover:bg-white border border-border-light p-3 rounded-full text-text-main transition-all shadow-[0_8px_20px_-6px_rgba(90,70,120,0.25)] ${activeIndex === carouselImages.length - 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Successivo" data-id="element-88">
              <ChevronRight className="w-5 h-5" data-id="element-89" />
            </button>

            <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 sm:gap-6 px-[10vw] sm:px-[calc(50%-175px)] pb-8 pt-4" data-id="element-90">
              {carouselImages.map((img, i) => <div key={i} className={`snap-center shrink-0 w-[80vw] sm:w-[350px] bg-bg-alt border border-border-light rounded-2xl overflow-hidden p-2 sm:p-3 flex items-center justify-center shadow-[0_12px_30px_-10px_rgba(90,70,120,0.25)] transition-all duration-300 ${activeIndex === i ? 'scale-100 opacity-100 border-primary/40' : 'scale-95 opacity-50'}`} data-id="element-91">
                  <img src={img.src} alt={img.alt} loading="lazy" decoding="async" width={800} height={1131} className="w-full h-auto max-h-[400px] sm:max-h-[450px] object-contain rounded-xl bg-white" data-id="element-92" />
                </div>)}
            </div>

            <div className="flex justify-center mb-2" data-id="element-93">
              <span className="bg-bg-alt border border-border-light text-text-sec text-xs font-bold px-3 py-1 rounded-full" data-id="element-94">
                {activeIndex + 1} / {carouselImages.length}
              </span>
            </div>
          </div>

          <div className="flex justify-center gap-1 mt-2" data-id="element-95">
            {carouselImages.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} className="p-3 flex items-center justify-center" aria-label={`Vai all'immagine ${i + 1}`} data-id="element-96">
                <span className={`block h-2 rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-primary w-8' : 'bg-border-light hover:bg-text-sec w-2'}`} data-id="element-97" />
              </button>)}
          </div>
        </div>

        <div className="mt-12 sm:mt-16 text-center" data-id="element-98">
          <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-cta-green hover:bg-cta-green-hover text-white font-black text-sm sm:text-base px-7 sm:px-9 py-3.5 sm:py-4 rounded-xl transition-all shadow-[0_12px_28px_-8px_rgba(15,139,111,0.5)]" data-id="element-99">
            Voglio accedere subito
            <ArrowRight className="w-4 h-4" data-id="element-100" />
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium mt-3" data-id="element-101">
            ⚡ Download immediato · 🛡️ Garanzia 7 giorni · 💳 Pagamento unico
          </p>
        </div>
      </div>
    </section>;
}